var React = require('react');

function CircleCrossInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#000","cx":"13.7495","cy":"13.7661","r":"12.2339","stroke":"#000","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M8.64648 8.66406L18.8509 18.8685","stroke":"#F6F4EA","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M8.64648 18.8687L18.8509 8.66421","stroke":"#F6F4EA","strokeWidth":"2","strokeLinecap":"round","key":2})]);
}

CircleCrossInline.defaultProps = {"viewBox":"0 0 27 27","fill":"none"};

module.exports = CircleCrossInline;

CircleCrossInline.default = CircleCrossInline;
